__webpack_require__.p = "/dagligbank-kontakt-meg-web/dist/";